export type PeriodStatus = 'before' | 'within' | 'after'
export const getPeriodStatus = (
  start: Date | null,
  end: Date | null,
): PeriodStatus | null => {
  const now = new Date()
  let startDate = start
  if (typeof startDate === 'string') {
    startDate = new Date(startDate)
  }

  let endDate = end
  if (typeof endDate === 'string') {
    endDate = new Date(endDate)
  }
  if (!startDate) return null
  if (startDate > now) return 'before'
  if (startDate < now && (!endDate || endDate > now)) return 'within'
  if (endDate && endDate < now) return 'after'

  return null
}
